(() => {
  if (window.__colchaMotionInitialized) return;
  window.__colchaMotionInitialized = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const main = document.getElementById('MainContent');
  const isHome = window.location.pathname === '/' || window.location.pathname === '';

  function setupCollectionCrossfade() {
    document.querySelectorAll('[data-colcha-hover-image]').forEach((card) => {
      if (card.dataset.colchaHoverReady === 'true') return;
      const src = card.dataset.colchaHoverImage;
      const target = card.querySelector('.collection-card__image');
      if (!src || !target) return;

      const img = document.createElement('img');
      img.className = 'colcha-collection-hover-image';
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      target.appendChild(img);
      card.dataset.colchaHoverReady = 'true';
    });
  }

  function setupReveal() {
    if (!isHome || !main || reduceMotion || !('IntersectionObserver' in window)) return;

    document.body.classList.add('colcha-motion-ready');

    const sections = Array.from(main.children).filter((el) => el.classList?.contains('shopify-section'));
    sections.forEach((section, index) => {
      if (index === 0 || section.querySelector('.hero')) {
        section.classList.add('is-visible');
        return;
      }
      section.classList.add('colcha-reveal');
    });

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    sections.filter((section) => section.classList.contains('colcha-reveal')).forEach((section) => observer.observe(section));

    const items = Array.from(document.querySelectorAll(
      '.colcha-pt__card, [data-testid="collection-list"] .resource-list__item'
    ));

    const itemObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -4% 0px' });

    items.forEach((item, index) => {
      item.classList.add('colcha-reveal-item');
      item.style.setProperty('--colcha-reveal-order', String(index % 4));
      itemObserver.observe(item);
    });
  }

  function setupHeroParallax() {
    if (!isHome || reduceMotion) return;
    const hero = document.querySelector('#MainContent .hero');
    if (!hero) return;

    hero.setAttribute('data-colcha-parallax', '');
    let ticking = false;

    const update = () => {
      ticking = false;
      const rect = hero.getBoundingClientRect();
      const viewport = window.innerHeight || 800;
      if (rect.bottom <= 0 || rect.top >= viewport) return;

      const travelled = Math.max(0, -rect.top);
      const maxShift = window.innerWidth < 750 ? 10 : 18;
      const y = Math.min(maxShift, travelled * 0.045);
      hero.style.setProperty('--colcha-parallax-y', y.toFixed(2) + 'px');
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  function setupCollectionPageMotion() {
    if (!main || reduceMotion || !main.dataset.template?.startsWith('collection') || !('IntersectionObserver' in window)) return;

    document.body.classList.add('colcha-collection-motion-ready');

    const title = main.querySelector('h1');
    if (title) title.classList.add('colcha-motion-title');

    const targets = [
      ...(title ? [title] : []),
      ...main.querySelectorAll('.colcha-motion-heading, .colcha-motion-product')
    ];

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });

    let cardIndex = 0;
    targets.forEach((target) => {
      if (target.classList.contains('colcha-motion-product')) {
        target.style.setProperty('--colcha-reveal-order', String(cardIndex % (window.innerWidth < 750 ? 2 : 4)));
        cardIndex += 1;
      } else {
        target.style.setProperty('--colcha-reveal-order', '0');
      }
      observer.observe(target);
    });
  }

  function setupCompleteTheLookMotion() {
    if (!main || reduceMotion || !main.dataset.template?.startsWith('product') || !('IntersectionObserver' in window)) return;

    const sections = Array.from(main.querySelectorAll('.colcha-ctl'));
    if (!sections.length) return;

    document.body.classList.add('colcha-ctl-motion-ready');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else if (entry.boundingClientRect.top > 0 || entry.boundingClientRect.bottom < 0) {
          entry.target.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -5% 0px' });

    const cards = [];

    sections.forEach((section) => {
      const heading = section.querySelector('.colcha-ctl__heading');
      if (heading) observer.observe(heading);

      section.querySelectorAll('.colcha-ctl__card').forEach((card, index) => {
        card.style.setProperty('--colcha-ctl-order', String(index));
        cards.push(card);
        observer.observe(card);
      });
    });

    let ticking = false;

    const updateScrollMotion = () => {
      ticking = false;
      const viewport = window.innerHeight || 800;
      const viewportCenter = viewport / 2;

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= viewport) return;

        const cardCenter = rect.top + rect.height / 2;
        const normalized = Math.max(-1, Math.min(1, (cardCenter - viewportCenter) / viewportCenter));
        const shift = normalized * -8;

        card.style.setProperty('--colcha-ctl-scroll-y', shift.toFixed(2) + 'px');
      });
    };

    const requestScrollMotion = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateScrollMotion);
    };

    window.addEventListener('scroll', requestScrollMotion, { passive: true });
    window.addEventListener('resize', requestScrollMotion, { passive: true });
    updateScrollMotion();
  }

  setupCollectionCrossfade();
  setupReveal();
  setupHeroParallax();
  setupCollectionPageMotion();
  setupCompleteTheLookMotion();

  function setupCheckoutCompleteTheLook() {
    if (window.__colchaCheckoutUpsellReady) return;
    window.__colchaCheckoutUpsellReady = true;

    let activeCheckoutButton = null;

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const checkoutButton = target.closest('.cart__checkout-button');
      if (checkoutButton) {
        if (checkoutButton.dataset.colchaCheckoutBypass === 'true') {
          delete checkoutButton.dataset.colchaCheckoutBypass;
          return;
        }

        const host = checkoutButton.closest('.cart-drawer__summary, .cart-summary__inner, .cart-summary');
        const modal = host?.querySelector('[data-colcha-checkout-upsell]');
        if (!(modal instanceof HTMLDialogElement)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        activeCheckoutButton = checkoutButton;

        if (!modal.open) {
          modal.showModal();
        }
        return;
      }

      const continueButton = target.closest('[data-colcha-upsell-continue]');
      if (continueButton) {
        const modal = continueButton.closest('[data-colcha-checkout-upsell]');
        if (modal instanceof HTMLDialogElement && modal.open) modal.close();

        if (activeCheckoutButton instanceof HTMLButtonElement) {
          activeCheckoutButton.dataset.colchaCheckoutBypass = 'true';
          activeCheckoutButton.click();
        }
        return;
      }

      const closeButton = target.closest('[data-colcha-upsell-close]');
      if (closeButton) {
        const modal = closeButton.closest('[data-colcha-checkout-upsell]');
        if (modal instanceof HTMLDialogElement && modal.open) modal.close();
      }
    }, true);
  }

  setupCheckoutCompleteTheLook();

  function setupBuyNowCompleteTheLook() {
    if (window.__colchaBuyNowUpsellReady) return;
    window.__colchaBuyNowUpsellReady = true;

    let activeBuyNowContext = null;

    const findBuyNowButton = (event) => {
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];

      for (const node of path) {
        if (!(node instanceof Element)) continue;
        if (
          node.matches('.shopify-payment-button__button') ||
          node.matches('[data-shopify="payment-button"] button') ||
          node.matches('.accelerated-checkout-block button')
        ) {
          return node;
        }
      }

      const target = event.target;
      if (!(target instanceof Element)) return null;
      return target.closest('.shopify-payment-button__button, [data-shopify="payment-button"] button, .accelerated-checkout-block button');
    };

    const addCurrentSelectionToExistingCartAndCheckout = async (context, actionButton) => {
      const formComponent = context?.formComponent;
      if (!(formComponent instanceof Element)) return;

      const variantField = formComponent.querySelector('input[name="id"]');
      const variantId = Number(variantField?.value || 0);
      if (!variantId) {
        window.alert('Please select an available option before checkout.');
        return;
      }

      const quantityField = formComponent.querySelector('[name="quantity"]');
      const parsedQty = Number.parseInt(quantityField?.value || '1', 10);
      const quantity = Number.isFinite(parsedQty) && parsedQty > 0 ? parsedQty : 1;

      const items = [{ id: variantId, quantity }];

      const sectionId = formComponent.dataset.sectionId || '';
      const addonsRoot = sectionId ? document.getElementById('colcha-addons-' + sectionId) : null;

      if (addonsRoot) {
        const bedsheetTitle = addonsRoot.dataset.bedsheetTitle || '';
        const forLabel = addonsRoot.dataset.forLabel || 'For';

        addonsRoot.querySelectorAll('input[data-addon-variant]:checked').forEach((input) => {
          const addonVariantId = Number(input.dataset.addonVariant || 0);
          if (!addonVariantId) return;

          const properties = {};
          properties[forLabel] = bedsheetTitle;

          items.push({
            id: addonVariantId,
            quantity,
            properties
          });
        });
      }

      const button = actionButton instanceof HTMLButtonElement ? actionButton : null;
      if (button) button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          let message = 'Unable to add this item to your cart.';
          try {
            const data = await response.json();
            message = data?.description || data?.message || message;
          } catch (_) {}
          throw new Error(message);
        }

        window.location.assign('/checkout');
      } catch (error) {
        console.error('COLCHA Buy It Now cart-preserving checkout failed', error);
        if (button) button.disabled = false;
        window.alert(error instanceof Error ? error.message : 'Unable to continue to checkout. Please try again.');
      }
    };

    document.addEventListener('click', (event) => {
      const buyNowButton = findBuyNowButton(event);

      if (buyNowButton) {
        const formComponent = buyNowButton.closest('product-form-component');
        if (!(formComponent instanceof Element)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        activeBuyNowContext = { button: buyNowButton, formComponent };

        const modal = formComponent.parentElement?.querySelector('[data-colcha-buy-now-upsell]') ||
          formComponent.querySelector('[data-colcha-buy-now-upsell]') ||
          document.querySelector('[data-colcha-buy-now-upsell]');

        if (modal instanceof HTMLDialogElement) {
          if (!modal.open) modal.showModal();
        } else {
          addCurrentSelectionToExistingCartAndCheckout(activeBuyNowContext, null);
        }
        return;
      }

      const target = event.target;
      if (!(target instanceof Element)) return;

      const continueButton = target.closest('[data-colcha-buy-now-continue]');
      if (continueButton) {
        const modal = continueButton.closest('[data-colcha-buy-now-upsell]');
        if (modal instanceof HTMLDialogElement && modal.open) modal.close();

        if (activeBuyNowContext) {
          addCurrentSelectionToExistingCartAndCheckout(activeBuyNowContext, continueButton);
        }
        return;
      }

      const closeButton = target.closest('[data-colcha-buy-now-close]');
      if (closeButton) {
        const modal = closeButton.closest('[data-colcha-buy-now-upsell]');
        if (modal instanceof HTMLDialogElement && modal.open) modal.close();
      }
    }, true);
  }

  setupBuyNowCompleteTheLook();

  document.addEventListener('shopify:section:load', () => {
    setupCollectionCrossfade();
  });
})();
